/*
  Own review system: the "write a review" form (snippets/review-form.liquid). This file is OURS.

  - Any element with data-review-form-toggle="<form id>" opens / closes the form.
  - On submit the fields are sent as JSON to the backend (attribute "endpoint"), which stores the review as a hidden
    draft and emails info@ for approval. The response carries { ok, error }.
  - elapsed_ms (time since the form was opened) and the hidden "website" field are spam traps checked by the backend.
*/

if (!customElements.get('review-form')) {
  class ReviewForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('.review-form__status');
      this.openedAt = Date.now();
      this.form.addEventListener('submit', (event) => this.submit(event));
    }

    toggle(force) {
      this.hidden = force === undefined ? !this.hidden : !force;
      document.querySelectorAll(`[data-review-form-toggle="${this.id}"]`).forEach((button) => {
        button.setAttribute('aria-expanded', String(!this.hidden));
      });
      if (!this.hidden) {
        this.openedAt = Date.now();
        this.querySelector('input[name="rating"]')?.focus({ preventScroll: true });
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    async submit(event) {
      event.preventDefault();
      this.status.replaceChildren();

      if (!this.form.reportValidity()) return;

      const data = new FormData(this.form);
      const submitButton = this.form.querySelector('[type="submit"]');
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(this.getAttribute('endpoint'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            product_id: this.getAttribute('product-id'),
            rating: Number(data.get('rating')),
            title: data.get('title'),
            body: data.get('body'),
            name: data.get('name'),
            email: data.get('email'),
            consent: data.get('consent') !== null,
            hp: data.get('website'),
            elapsed_ms: Date.now() - this.openedAt
          })
        });
        const result = await response.json().catch(() => ({}));

        if (response.ok && result.ok) {
          this.form.replaceWith(this.querySelector('.review-form__success').content.cloneNode(true));
          return;
        }
        this.showError(result.error);
      } catch {
        this.showError();
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }

    showError(message) {
      const banner = this.querySelector('.review-form__error').content.cloneNode(true);
      banner.querySelector('.review-form__error-text').textContent =
        message || 'Die Bewertung konnte gerade nicht gesendet werden. Bitte versuchen Sie es später erneut.';
      this.status.replaceChildren(banner);
    }
  }

  customElements.define('review-form', ReviewForm);

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-review-form-toggle]');
    if (!toggle) return;
    document.getElementById(toggle.getAttribute('data-review-form-toggle'))?.toggle();
  });
}
